import {
  HeadingTitle,
  SubHeadingTitle
} from "../../../components/shared/index";
import styles from "./aboutus.module.css";
import { PiBriefcaseLight } from "react-icons/pi";
import { LiaAwardSolid } from "react-icons/lia";
import { IoBulbOutline } from "react-icons/io5";
import { LiaSmileBeam } from "react-icons/lia";
const Stats = () => {
  return (
    <div className={styles.stats}>
      <div className={styles.statItem}>
        <PiBriefcaseLight className={styles.icon} /> 
        <HeadingTitle text="3190" style={styles.statHeading} />
        <SubHeadingTitle
          subTitle="Sales"
          style={styles.statSubHeading}
        />
      </div>
      <div className={styles.statItem}>
        <LiaAwardSolid className={styles.icon} />
        <HeadingTitle text="1950" style={styles.statHeading} />
        <SubHeadingTitle
          subTitle="Reordered"
          style={styles.statSubHeading}
        />
      </div>
      {/* <div className={styles.statItem}>
        <IoBulbOutline className={styles.icon} />
        <HeadingTitle text="689" style={styles.statHeading} />
        <SubHeadingTitle
        subTitle="Hours Worked"
          style={styles.statSubHeading}
        />
      </div> */}
      <div className={styles.statItem}>
        <LiaSmileBeam className={styles.icon} /> 
        <HeadingTitle text="1750" style={styles.statHeading} />
        <SubHeadingTitle
          subTitle="Happy Customers"
          style={styles.statSubHeading}
        />
      </div>
    </div>
  );
};
export default Stats;